import { takeEvery, call, put, all, fork } from "redux-saga/effects";
import { authAction } from "../slice/authSlice";
import { loginApi, registerApi, forgotPasswordApi, updateAccountApi, getInfoApi, changePasswordApi } from "services/authServices"
import { role } from "common/general"

function* loginSagas(props) {
    const { values, setFieldError, setErrorMessage } = props.payload
    const res = yield call(loginApi, values)
    if (res.status === 200) {
        const dataResponse = res.data
        if (dataResponse.success) {
            const info = dataResponse.data
            let roleUser = role.CUSTOMER
            if (dataResponse.data.user.status === 1) {
                setErrorMessage("Tài khoản đã bị khóa")
                yield put(authAction.loginFailed())
            }
            else {
                if (dataResponse.data.user.permission === 0) {
                    roleUser = role.ADMIN
                }
                if (dataResponse.data.user.permission === 1) {
                    roleUser = role.STAFF
                }
                if (dataResponse.data.user.permission === 2) {
                    roleUser = role.CUSTOMER
                }
                localStorage.setItem("userInfo", JSON.stringify({ info: info, role: roleUser }))
                yield put(authAction.loginSuccess({ info: info, role: roleUser }))
            }
        }
        else {
            setFieldError(dataResponse.data[0], dataResponse.data[1])
            yield put(authAction.loginFailed())

        }
    } else {
        yield put(authAction.loginFailed())
    }
}

function* registerSagas(props) {
    const { values, setFieldError, navigate, ShowToast } = props.payload
    const res = yield call(registerApi, values)
    if (res.status === 200) {
        const dataResponse = res.data
        if (dataResponse.success) {
            yield put(authAction.registerSuccess())
            navigate("/login")
            ShowToast("success", "Đăng ký tài khoản thành công!")
        }
        else {
            setFieldError(dataResponse.data[0], dataResponse.data[1])
            yield put(authAction.registerFailed())

        }
    } else {
        yield put(authAction.registerFailed())
    }
}


function* forgotPasswordSagas(props) {
    const { values, setFieldError, ShowToast } = props.payload
    const res = yield call(forgotPasswordApi, values)
    if (res.status === 200) {
        const dataResponse = res.data
        if (dataResponse.success) {
            yield put(authAction.forgotPasswordSuccess())
            ShowToast("success", "Quên mật khẩu thành công, vui lòng kiểm tra email của bạn!")
        }
        else {
            setFieldError(dataResponse.data[0], dataResponse.data[1])
            yield put(authAction.forgotPasswordSuccess())

        }
    } else {
        yield put(authAction.forgotPasswordFailed())
    }
}

function* changeAvatarSagas(props) {
    const { data, ShowToast } = props.payload
    const userInfo = JSON.parse(localStorage.getItem("userInfo"))
    const res = yield call(updateAccountApi, data)
    if (res.status === 200) {
        const dataResponse = res.data
        if (dataResponse.success) {
            yield put(authAction.changeAvatarSuccess(data.avatar))
            ShowToast("success", "Thay đổi ảnh đại diện thành công")
            if (userInfo) {
                const token = userInfo.info.token
                const refresh = userInfo.info.refresh
                const role = userInfo.role
                const user = { ...userInfo.info.user, avatar: data.avatar }
                localStorage.setItem("userInfo", JSON.stringify({ info: { token, refresh, user }, role: role }))
            }
        }
        else {
            yield put(authAction.changeAvatarFailed())
            ShowToast("error", "Thay đổi ảnh đại diện thất bại")
        }
    } else {
        yield put(authAction.changeAvatarFailed())
        ShowToast("error", "Thay đổi ảnh đại diện thất bại")
    }
}

function* updateAccountSagas(props) {
    const { data, setIsEdit, setFieldError, ShowToast } = props.payload
    const userInfo = JSON.parse(localStorage.getItem("userInfo"))
    const res = yield call(updateAccountApi, data)
    if (res.status === 200) {
        const dataResponse = res.data
        if (dataResponse.success) {
            ShowToast("success", "Cập nhật thông tin thành công")
            const token = userInfo.info.token
            const refresh = userInfo.info.refresh
            const role = userInfo.role
            const user = { ...userInfo.info.user, ...dataResponse.data }
            setIsEdit(false)
            yield put(authAction.updateAccountSuccess({ info: { token, refresh, user }, role: role }))
            localStorage.setItem("userInfo", JSON.stringify({ info: { token, refresh, user }, role: role }))
        }
        else {
            setFieldError(dataResponse.data[0], dataResponse.data[1])
            yield put(authAction.updateAccountFailed())
        }
    } else {
        yield put(authAction.updateAccountFailed())
    }
}



function* getInfoSagas() {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"))
    if (userInfo) {
        const res = yield call(getInfoApi)
        if (res.status === 200) {
            const dataResponse = res.data
            if (dataResponse.success) {
                const token = userInfo.info.token
                const refresh = userInfo.info.refresh
                const data = { user: dataResponse.data, token, refresh }
                let roleUser = role.CUSTOMER
                if (dataResponse.data.permission === 0) {
                    roleUser = role.ADMIN
                }
                if (dataResponse.data.permission === 1) {
                    roleUser = role.STAFF
                }
                if (dataResponse.data.permission === 2) {
                    roleUser = role.CUSTOMER
                }

                localStorage.setItem("userInfo", JSON.stringify({ info: data, role: roleUser }))
                yield put(authAction.getInfoSuccess({ info: data, role: roleUser }))
            }
            else {
                yield put(authAction.getInfoFailed())

            }
        } else {
            yield put(authAction.getInfoFailed())
        }
    }

}

function* changePassword(props) {
    const { data, setFieldError, callBack } = props.payload
    const res = yield call(changePasswordApi, data)
    if (res.status === 200) {
        const dataResponse = res.data
        if (dataResponse.success) {
            callBack()
            yield put(authAction.changePasswordSuccess())
        }
        else {
            setFieldError(dataResponse.data[0], dataResponse.data[1])
            yield put(authAction.changePasswordFailed())
        }
    } else {
        yield put(authAction.changePasswordFailed())
    }
}



function* watchAuthenticated() {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"))
    if (userInfo) {
        yield put(authAction.loginSuccess(userInfo))
    }
}


function* logoutSagas(props) {
    const { navigate } = props.payload
    yield localStorage.removeItem("userInfo")
    navigate("/login")
}


export default function* auth() {
    yield all(
        [
            fork(watchAuthenticated),
            takeEvery(authAction.login, loginSagas),
            takeEvery(authAction.logout, logoutSagas),
            takeEvery(authAction.register, registerSagas),
            takeEvery(authAction.forgotPassword, forgotPasswordSagas),
            takeEvery(authAction.changeAvatar, changeAvatarSagas),
            takeEvery(authAction.getInfo, getInfoSagas),
            takeEvery(authAction.updateAccount, updateAccountSagas),
            takeEvery(authAction.changePassword, changePassword),
        ]
    );
}
